import { JOB_STATUS } from '../../../constants/dentist/jobStatus';
import { ProcessedJob } from '../../../types/dentist/calendar';

const assertNeverStatus = (status: never): never => {
  throw new Error(`Unhandled dentist job status: ${status}`);
};

export const getDentistJobsForDateNavigation = (
  job: ProcessedJob,
  jobCount: number,
  unifiedEnabled: boolean,
) => {
  const params = { id: job.id, jobCount, jobId: job.id };
  if (unifiedEnabled) {
    if (job.status === JOB_STATUS.CONFIRMED) {
      return { pathname: 'dentistJobConfirmed', state: params };
    }
    if (job.status === JOB_STATUS.COMPLETED) {
      return { pathname: 'jobCompleted', state: params };
    }
    return { pathname: 'jobPosted', state: params };
  }

  switch (job.status) {
    case JOB_STATUS.POSTED:
      if (job.hasRemovedOffers && !job.hasActiveOffers) {
        return { pathname: 'dentistCustomOffers', state: params };
      }
      return { pathname: 'jobPosted', state: params };
    case JOB_STATUS.PARTIAL:
      return { pathname: 'dentistCustomOffers', state: params };
    case JOB_STATUS.CONFIRMED:
      return { pathname: 'dentistJobConfirmed', state: params };
    case JOB_STATUS.COMPLETED:
      return { pathname: 'jobCompleted', state: params };
    case JOB_STATUS.OFFER_EXPIRED:
      return { pathname: 'dentistCustomOffers', state: params };
    default:
      return assertNeverStatus(job.status);
  }
};

